import { render } from "./BrokerTxnsEditModalPopup.vue?vue&type=template&id=2de66f0c&scoped=true"
import script from "./BrokerTxnsEditModalPopup.vue?vue&type=script&lang=js"
export * from "./BrokerTxnsEditModalPopup.vue?vue&type=script&lang=js"

import "./BrokerTxnsEditModalPopup.vue?vue&type=style&index=0&id=2de66f0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de66f0c"]])

export default __exports__